<template>
  <el-dropdown trigger="click" class='international' @command="handleSetLanguage" width="150">
    <div>
      <svg-icon class-name='international-icon' icon-class="language" />
      <a v-show="langType == true? true:false" class="title-language">{{language == 'zh' ?  '中文(简体)': language == 'ko' ? '한국어':'English'}}</a>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh" :disabled="language==='zh'">中文(简体)</el-dropdown-item>
      <el-dropdown-item command="en" :disabled="language==='en'">English</el-dropdown-item>
      <el-dropdown-item command="zh_ft" :disabled="language==='zh_ft'">中文(繁體)</el-dropdown-item>
      <!-- <el-dropdown-item command="ko" :disabled="language==='ko'">한국어</el-dropdown-item>-->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  export default {
    props:{
      langType:{//是否显示复选框
        type:Boolean,
        default:true

      },
    },
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    methods: {
      handleSetLanguage(lang) {
        this.$i18n.locale = lang
        this.$store.dispatch('setLanguage', lang)
        // this.$message({
        //   message: 'switch language success',
        //   type: 'success'
        // })
      }
    }
  }
</script>

<style scoped>
  .international-icon {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -5px!important;
  }
  .title-language{
    font-size:16px;
    font-family:inter;
    color:rgba(64,158,255,1);
    line-height:20px;
    text-decoration:underline;
  }
</style>





// WEBPACK FOOTER //
// src/components/LangSelect/index.vue